import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WidgetDetail} from '../../../../../../../../domain/widget/model/widget-detail';
import {DomainUrlService} from '../../../../../../../../application/config/domain-url.service';
import {UserContextService} from '../../../../../../../../application/app-context/user-context/user-context.service';
import {AmplitudeService} from '../../../../../../../../application/analytics/service/amplitude.service';
import {SubcategoryWithArticles} from '../../../../../../../../domain/publications/model/subcategory-with-articles';
import {Article} from '../../../../../../../../domain/publications/model/article';

@Component({
             selector: 'app-widget-publication-latest-videos-large',
             templateUrl: './home-dashboard-widget-publication-latest-videos-large.component.html'
           })
export class HomeDashboardWidgetPublicationLatestVideosLargeComponent implements OnInit {

  readonly TRACK_ACTION_CLICK_LAST_VIDEO_ITEM = 'Widget_VideosLarge_DisplayVideo';

  @Input() widget: WidgetDetail | undefined;
  @Input() articlesWithVideo: Array<Article> | undefined;
  @Output() actionEvent = new EventEmitter<string>();

  accountId: string;
  publicationUrl: string;
  faTvUrl: string;

  constructor(private domainUrlService: DomainUrlService,
              private userContextService: UserContextService,
              private amplitudeService: AmplitudeService) {
  }

  ngOnInit(): void {
    this.accountId = this.userContextService.getUserContext().accountId;
    this.publicationUrl = this.domainUrlService.getPublicationUrl();
    this.faTvUrl = this.publicationUrl.concat('/decryptages-video/');
  }

  onClickTrackActionFATV(): void {
    this.amplitudeService.trackEventProperties('Widget_VideosLarge_DisplayAllVideos', new Map<string, string>());
  }

}
